import { isStandalone, requestInstall } from "./install";

const PROBE_TIMEOUT_MS = 8000;
const PROBE_RETRY_MS = 1200;

const createButton = (label, className = "") => {
  const button = document.createElement("button");
  button.type = "button";
  button.className = className;
  button.textContent = label;
  return button;
};

export const createPwaUi = (config, telemetry) => {
  const isAuthFlow = Boolean(document.querySelector(
    'form[id*="login" i], form[id*="register" i], form[id*="join" i], form[action*="/login" i], form[action*="/join" i]'
  ));
  const root = document.createElement("div");
  root.className = "ceoweb-pwa-ui";
  if (isAuthFlow) root.classList.add("ceoweb-pwa-ui--auth");
  root.setAttribute("aria-live", "polite");

  const status = document.createElement("div");
  status.className = "ceoweb-pwa-status";
  status.setAttribute("role", "status");
  status.dataset.state = "online";
  status.innerHTML = '<span class="ceoweb-pwa-status__dot"></span><span class="ceoweb-pwa-status__text">В сети</span>';
  root.appendChild(status);
  document.body.appendChild(root);

  const text = status.querySelector(".ceoweb-pwa-status__text");
  let installButton = null;
  let probeSequence = 0;
  let offlineReported = false;

  const setNetworkState = (state) => {
    const online = state === "online";
    const offline = state === "offline";
    status.dataset.state = state;
    text.textContent = online
      ? "В сети"
      : (offline ? "Не в сети" : "Сервер отвечает медленно");
    if (!offline) {
      offlineReported = false;
    } else if (!offlineReported) {
      offlineReported = true;
      telemetry("offline_navigation", { app_type: config.appType });
    }
  };

  const probeNetwork = async (retry = true) => {
    const sequence = ++probeSequence;
    const controller = typeof AbortController !== "undefined" ? new AbortController() : null;
    const timer = controller
      ? window.setTimeout(() => controller.abort(), PROBE_TIMEOUT_MS)
      : null;

    try {
      const response = await fetch(config.versionUrl || "/api/pwa/version", {
        method: "GET",
        credentials: "same-origin",
        cache: "no-store",
        headers: { Accept: "application/json" },
        signal: controller?.signal,
      });
      if (!response.ok) {
        throw new Error(`PWA probe failed with HTTP ${response.status}`);
      }
      if (timer) window.clearTimeout(timer);
      if (sequence === probeSequence) setNetworkState("online");
      return true;
    } catch (error) {
      if (timer) window.clearTimeout(timer);
      if (sequence !== probeSequence) return false;
      if (retry) {
        window.setTimeout(() => probeNetwork(false), PROBE_RETRY_MS);
        return false;
      }
      setNetworkState(window.navigator.onLine === false ? "offline" : "degraded");
      return false;
    }
  };

  window.addEventListener("online", () => probeNetwork());
  window.addEventListener("offline", () => probeNetwork());
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") probeNetwork();
  });
  probeNetwork();

  return {
    showInstall({ ios }) {
      if (isAuthFlow || isStandalone() || installButton) return;
      installButton = createButton(
        ios ? "Как установить на iPhone/iPad" : "Установить приложение",
        "ceoweb-pwa-install btn btn-sm btn-theme"
      );
      installButton.addEventListener("click", async () => {
        const outcome = await requestInstall();
        if (outcome === "ios-instructions") {
          window.alert("В Safari нажмите «Поделиться», затем выберите «На экран Домой».");
          telemetry("install_prompt_shown", { app_type: config.appType });
          return;
        }
        if (outcome === "accepted" || outcome === "dismissed") {
          telemetry(`install_${outcome}`, { app_type: config.appType });
          installButton?.remove();
          installButton = null;
          return;
        }
        window.alert("Этот браузер пока не предлагает установку. Сайт продолжит работать во вкладке.");
      });
      root.appendChild(installButton);
    },
    showUpdate(apply) {
      telemetry("update_available", { app_type: config.appType });
      apply();
    },
    probeNetwork,
  };
};
